import React from 'react';
import { Link } from 'components/link/Link';
import { ILink } from 'utils/types';

import s from './Shareholder.module.scss';

type Props = {
  title?: React.ReactNode;
  link: ILink;
};

export const Document = ({ title, link }: Props) => {
  if (!link || !link.href) {
    return null;
  }

  return (
    <div className={s.report}>
      <Link className={s.report__link} {...link} target="_blank">
        {title || 'Document name'}
      </Link>
    </div>
  );
};
